"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Toolbar.default;
  }
});

var _Toolbar = _interopRequireDefault(require("./Toolbar"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/Toolbar/index.js
// module id = 122
// module chunks = 0